var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Down",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3138 32.3537C25.0494 32.642 24.6013 32.6615 24.313 32.3971L9.15234 18.4975C8.28769 17.6977 8.27598 16.3083 9.15664 15.5127C9.15759 15.5118 9.15853 15.511 9.15948 15.5101L24.3127 1.60311C24.6009 1.33859 25.049 1.35781 25.3135 1.64603C25.578 1.93425 25.5588 2.38233 25.2706 2.64684L10.1072 16.5632C9.85765 16.7878 9.84658 17.2089 10.1135 17.4567C10.1138 17.457 10.1132 17.4565 10.1135 17.4567L25.2703 31.3529C25.5587 31.6172 25.5781 32.0653 25.3138 32.3537Z",
    fill: "#EF233C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b4137f01c27966393d4be4f5f8a6c7a9.svg";
export { ForwardRef as ReactComponent };